<template>
  <div id="app">
    <notifications
      group="AppGeneralUser"
      position="bottom right"
      :duration="5000"
    />

    <div
      id="wrapper"
      class="d-flex"
    >
      <Sidebar v-if="isAuthenticatedMiddlewareAuth" />

      <div
        class="w-100"
        :class="isAuthenticatedMiddlewareAuth ? 'main_content_wrapper' : null"
      >
        <landing-header-vue v-if="!isAuthenticatedMiddlewareAuth" />
        <b-button
          v-if="isAuthenticatedMiddlewareAuth && isSmallScreen"
          class="navbar-collapse-button d-sm-block"
          @click="toggleSidebar"
        >
          <b-icon
            :icon="isNavbarCollapsed ? 'list' : 'x'"
          />
        </b-button>
        <b-collapse
          id="sidebarNavCollapse"
          :visible="!isNavbarCollapsed || !isSmallScreen"
        >
          <b-navbar
            v-if="isAuthenticatedMiddlewareAuth"
            id="nav-bar-top"
            toggle-class="text-decoration-none"
            no-caret
            class="top-nav-bar-lg fixed navbar-wrap"
            :class="{'expanded': !isNavbarCollapsed,
                     'collapsed': isNavbarCollapsed,
                     'bg-gray':isSmallScreen && !isNavbarCollapsed,
                     'px-20':isSmallScreen && !isNavbarCollapsed
            }"
          >
            <b-navbar-nav
              id="bnavbar-nav"
              class="ml-auto d-flex flex-wrap"
              :class="{'mr-auto':isSmallScreen && !isNavbarCollapsed, 'nav-expanded': !isNavbarCollapsed}"
            >
              <div
                v-b-hover="handleHelpHover"
                v-b-tooltip.hover.bottom="'Context Help'"
                right
                toggle-class="text-decoration-none"
                class="ml-auto px-2"
                no-caret
                @click="setVisibleLearningCntxlHelp(true)"
              >
                <b-icon
                  v-if="hoverHelp"
                  aria-label="Help"
                  icon="question-circle-fill"
                  font-scale="2"
                  class="icon-help"
                />
                <b-icon
                  v-else
                  aria-label="Help"
                  icon="question-circle"
                  font-scale="2"
                  class="icon-help"
                />
              </div>
              <b-nav-item-dropdown
                v-b-tooltip.hover.bottom="'Terms and Conditions'"
                right
                size="lg"
                toggle-class="text-decoration-none"
                class="ml-3 px-2"
                no-caret
              >
                <template #button-content>
                  <b-icon
                    aria-label="Help"
                    icon="card-heading"
                    font-scale="1"
                    class="text-coolGray-500 hover:text-coolGray-900 font-medium"
                  />
                </template>
                <b-dropdown-item @click="openTermsCondi">
                  Terms and Conditions
                </b-dropdown-item>
                <b-dropdown-item @click="openCookies">
                  Cookies Policy
                </b-dropdown-item>
                <b-dropdown-item @click="openPrivacy">
                  Privacy Policy
                </b-dropdown-item>
              </b-nav-item-dropdown>
              <a
                v-b-tooltip.hover.bottom="'djuli API'"
                class="
              text-coolGray-500
              hover:text-coolGray-900
              font-medium p-2 
            "
                href="https://feature-extraction-value-zu3hsmhdza-nw.a.run.app/api-docs/"
                target="_blank"
              >
                <b-icon
                  icon="cpu"
                  font-scale="1.5"
                  class="text-coolGray-500 hover:text-coolGray-900 font-medium"
                />
              </a>
              <router-link
                class="
              text-coolGray-500
              hover:text-coolGray-900
              font-medium p-2 my-auto
            "
                active-class="selected"
                to="/pricing/details"
              >
                Pricing
              </router-link>
              <router-link
                class="
              text-coolGray-500
              hover:text-coolGray-900
              font-medium p-2 my-auto
            "
                active-class="selected"
                to="/feedback"
              >
                Feedback
              </router-link>
              <router-link
                class="
              text-coolGray-500
              hover:text-coolGray-900
              font-medium p-2 my-auto
            "
                active-class="selected"
                to="/requests"
              >
                <b-icon
                  v-if="!isSmallScreen"
                  v-b-tooltip.hover.bottom="`Requests`"
                  icon="inbox-fill"
                />
                <b-badge
                  v-if="!isSmallScreen"
                  v-b-tooltip.hover.bottom="`Requests`"
                  pill
                  variant="danger"
                >
                  {{ getTotalIncomingPendingAccessRequestsMiddleware || 0 }}
                </b-badge>
                <span v-if="isSmallScreen">Requests ({{ getTotalIncomingPendingAccessRequestsMiddleware || 0 }})</span>
              </router-link>
              <b-nav-item-dropdown
                right
                class="px-2"
              >
                <template #button-content>
                  <em
                    class="
                  text-coolGray-500
                  hover:text-coolGray-900
                  font-medium
                  not-italic
                "
                  >{{ userName }}</em>
                </template>
                <b-dropdown-item
                  class="text-coolGray-500 hover:text-coolGray-900 font-medium"
                  @click="$router.push('/accountSummary')"
                >
                  Subscription status
                </b-dropdown-item>
                <b-dropdown-item
                  class="text-coolGray-500 hover:text-coolGray-900 font-medium"
                  @click="logout"
                >
                  Logout
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-navbar>
        </b-collapse>
        <b-sidebar
          id="learning-sidebar"
          ref="sidebarLearning"
          v-model="learningVisible"
          title="Learning Mode"
          :no-close-on-esc="true"
          :no-close-on-route-change="true"
          right
          shadow
          :width="widthLearningSideBar"
        >
          <div
            class="hold-sign"
            :class="{ 'hold-sign-show': isHoldLearningCntxHelp }"
            @click="setHoldLearningCntxHelp(false)"
          >
            Hold
          </div>
          <ContextualHelp class="ml-3" />
        </b-sidebar>

        <b-container
          id="mainContainer"
          ref="scrollableContainer"
          fluid
          class="scrollable-container"
          :class="{main_content:isAuthenticatedMiddlewareAuth, main_content_no_auth:!isAuthenticatedMiddlewareAuth}"
          @scroll="handleScroll"
        >
          <b-row class="h-100">
            <b-col class="main-information overflow-hidden">
              <router-view v-slot="slotProps">
                <transition
                  name="route"
                  mode="out-in"
                >
                  <component :is="slotProps.Component" />
                </transition>
              </router-view>
            </b-col>
            <b-col
              v-if="isVisibleLearningCntxlHelp"
              ref="bColLearning"
              class="learning-mode m-0 p-0"
              :cols="isSmallScreen ? '5':'3'"
            />
            <BackToTopButton
              :is-visible="isVisible"
              @scrollToTop="scrollToTop"
            />
          </b-row>
        </b-container>
        <div
          v-if="isLoadingMainApp"
          class="opaque-main-div"
        >
          <div class="opaque-main-loading">
            <b-spinner
              variant="success"
              style="width: 6rem; height: 6rem"
              label="Large Spinner Text Centered"
            />
          </div>
        </div>
      </div>
    </div>
    <footer>
      <cookie-law theme="dark-lime">
        <template #message>
          <p class="title-cookies">
            THIS SITE USES COOKIES TO OFFER YOU A BETTER BROWSING EXPERIENCE!
          </p>
          <p>
            We use different kind of cookies to optimize djuli web service
            functionality and give you the best possible experience. Cookies
            enable you to enjoy all features of our website and to tailor
            content to your interests. They also help us understand how our site
            is being used and optimize it for you. For more information
            <router-link to="cookies-policy">
              Click here
            </router-link>
          </p>
        </template>
      </cookie-law>
    </footer>
  </div>
</template>

<script>
import Sidebar from './components/mainWindow/SideBar';
import CookieLaw from 'vue-cookie-law';
import ContextualHelp from './components/mainWindow/ContextualHelp';
import { mapGetters, mapActions } from 'vuex';
import landingHeaderVue from './newUI/landingHeader.vue';
import { getAuth } from 'firebase/auth';
import {firebaseApp} from '@/firebaseConfig';
import BackToTopButton from '@/components/common/BackToTopButton.vue';

const zoneNotify = 'MainApp';
const KEY_RELEASE_LEARNING = 27;
const KEY_COMB_HOLD = 17;
const auth = getAuth(firebaseApp);

//Timers values
const timerAutosave = 300000;
const waitingConfirmationExtend = 180000;

export default {
  name: 'App',
  components: {
    Sidebar,
    ContextualHelp,
    CookieLaw,
    landingHeaderVue,
		BackToTopButton,
  },
  data() {
    return {
      hoverHelp: false,
      widthLearningSideBar: '444px',
      autosaveTimer: null,
			isNavbarCollapsed: false,
			isSmallScreen: false,
			isVisible: false,
    };
  },
  computed: {
    ...mapGetters([
      'isVisibleLearningCntxlHelp',
      'isHoldLearningCntxHelp',
      'isSessionExpiredMainApp',
      'isAutoLogoutMiddlewareAuth',
      'getDisplayNameMiddlewareAuth',
      'isAuthenticatedMiddlewareAuth',
      'isTrustPCMiddlewareAuth',
      'isLoadingMainApp',
      'isBtnHoldSetCntxHelp',
      'isReportModifiedReportViewer',
			'getTotalIncomingPendingAccessRequestsMiddleware',
			'getTotalPersonalPendingAccessRequestsMiddleware',
      'getWidthWindowMainApp'
    ]),
    learningVisible: {
      set(value) {
        this.setVisibleLearningCntxlHelp(value);
      },
      get() {
        return this.isVisibleLearningCntxlHelp;
      },
    },
    userName: {
      get() {
        if (this.getDisplayNameMiddlewareAuth === '') {
          return 'User';
        }
        return this.getDisplayNameMiddlewareAuth;
      },
    },
  },
  watch: {
    isVisibleLearningCntxlHelp(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const newWidth = `${this.$refs.bColLearning.clientWidth}px`;
          this.widthLearningSideBar = newWidth;
          this.setWidthLearningCntxlHelp(newWidth);
        });
      }
    },
    async isAutoLogoutMiddlewareAuth(cur, old) {
      //Check if the session was stopped
      if (cur && cur !== old) {
        this.setAutoLogoutMiddlewareAuth(false);
        await this.tryRecoverSession();
      }
    },
    async isSessionExpiredMainApp(newVal) {
      if (newVal) {
        this.setSessionExpiredMainApp(false);
        await this.logout();
      }
    },
    isReportModifiedReportViewer(value, oldValue) {
      if (value && !oldValue) {
        //If it changed to new value
        this.autosaveTimer = setTimeout(() => {
          this.setAutoSaveReportViewer(true);
          return;
        }, timerAutosave);
      } else if (!value) {
        if (this.autosaveTimer !== null) {
          clearTimeout(this.autosaveTimer);
          this.autosaveTimer = null;
        }
      }
    },
		$route() {
			this.isNavbarCollapsed = true;
		},
  },
  async created() {
    const returnCode = await this.tryLoginMiddlewareAuth();
    if (returnCode === 1) {
      //Needs to signout
      await this.logout();
    }
    window.addEventListener('keyup', this.onKeyUp);
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('copy', this.formatCopyFunction);
    window.addEventListener('resize', this.onResizeWindow);
    window.onbeforeunload = this.onCloseApp;
		window.addEventListener('resize', this.updateWindowSize);
    this.setWidthWindowMainApp(window.innerWidth);
    this.setHeightWindowMainApp(window.innerHeight);
    if(auth?.currentUser?.email){
      this.fetchResourceAccessRequestsMiddleware({email: auth.currentUser.email}) // TODO: User email should be fetched from backend
    }
    this.updateWindowSize();
  },
  unmounted() {
    window.removeEventListener('keyup', this.onKeyUp);
    window.removeEventListener('keydown', this.onKeyDown);
    window.addEventListener('copy', this.formatCopyFunction);
    window.addEventListener('resize', this.onResizeWindow);
    window.onbeforeunload = null;
  },
  methods: {
    ...mapActions([
      'setVisibleLearningCntxlHelp',
      'setWidthLearningCntxlHelp',
      'setHoldLearningCntxHelp',
      'setSessionExpiredMainApp',
      'tryLoginMiddlewareAuth',
      'logoutMiddlewareAuth',
      'setAutoLogoutMiddlewareAuth',
      'updateTokenMiddlewareAuth',
      'setWidthWindowMainApp',
      'setHeightWindowMainApp',
      'setBtnHoldSetCntxHelp',
      'setAutoSaveReportViewer',
			'fetchResourceAccessRequestsMiddleware'
    ]),
		handleScroll() {
      const container = this.$refs.scrollableContainer;
      this.isVisible = container.scrollTop > this.getWidthWindowMainApp / 10;
    },
    scrollToTop() {
      const container = this.$refs.scrollableContainer;
      container.scrollTo({ top: 0, behavior: 'smooth' });
    },
    async tryRecoverSession() {
      try {
        if (
          typeof this.isTrustPCMiddlewareAuth !== 'undefined' &&
          this.isTrustPCMiddlewareAuth !== null &&
          this.isTrustPCMiddlewareAuth
        ) {
          const success = await this.updateTokenMiddlewareAuth();
          if (!success) {
            this.tryRecoverSession(); //It tries again
          }
          return;
        }
      } catch {
        const errTitle = 'Error extending the session';
        const errText =
          'Error extending the session. Please contact the administrator of the system.';
        this.$notifTerm.addNotification(
          this.$notifTerm.typesNotif.ERROR,
          errTitle,
          errText,
          zoneNotify
        );
        await this.logout();
        return;
      }
      const timerAuto = setTimeout(async () => {
        // Save the report before closing if modified
        if (
          this.$route.name === 'ReportViewer' &&
          this.isReportModifiedReportViewer
        ) {
          await this.$refs.routerCmpLoaded.saveReport();
        }
        await this.logout();
        return;
      }, waitingConfirmationExtend);
      try {
        await this.$confirm(
          'Your session is about to expire. Do you want to extend it?',
          'Session Expire',
          'question'
        );
        clearTimeout(timerAuto);
        const success = await this.updateTokenMiddlewareAuth();
        if (!success) {
          this.tryRecoverSession(); //It tries again
        }
      } catch {
        clearTimeout(timerAuto);
        if (
          this.$route.name === 'ReportViewer' &&
          this.isReportModifiedReportViewer
        ) {
          await this.$refs.routerCmpLoaded.saveReport();
        }
        await this.logout();
        return;
      }
    },
    handleHelpHover(hovered) {
      //Handle the hover on the help icon
      this.hoverHelp = hovered;
    },
    onKeyUp(e) {
      if (e.keyCode === KEY_RELEASE_LEARNING) {
        //Key for freeze the Learning Mode released
        if (this.isHoldLearningCntxHelp) {
          //This avoids multiple executions of the code
          this.setHoldLearningCntxHelp(false);
        }
      } else if (e.keyCode === KEY_COMB_HOLD || e.metaKey) {
        //Key for freeze the Learning Mode released
        if (this.isBtnHoldSetCntxHelp) {
          //This avoids multiple executions of the code
          this.setBtnHoldSetCntxHelp(false);
        }
      }
    },
    onKeyDown(e) {
      if (e.keyCode === KEY_COMB_HOLD || e.metaKey) {
        //Key for freeze the Learning Mode released
        if (!this.isBtnHoldSetCntxHelp) {
          //This avoids multiple executions of the code
          this.setBtnHoldSetCntxHelp(true);
        }
      }
    },
    formatCopyFunction(e) {
      const text_only = document.getSelection().toString();
      const clipdata = e.clipboardData || window.clipboardData;
      clipdata.setData('text/plain', text_only);
      clipdata.setData('text/html', text_only);
      e.preventDefault();
    },
    async logout() {
      await this.logoutMiddlewareAuth();
      if (this.$route.name !== 'login') {
        this.$router.go({ path: this.$router.path });
      }
    },
    openTermsCondi() {
      this.$router.push('/terms-conditions');
    },
    openCookies() {
      this.$router.push('/cookies-policy');
    },
    openPrivacy() {
      this.$router.push('/privacy-policy');
    },
    onResizeWindow() {
      this.setWidthWindowMainApp(window.innerWidth);
      this.setHeightWindowMainApp(window.innerHeight);
			this.isSmallScreen = window.innerWidth < 1160;
			if(this.isSmallScreen){
				this.isNavbarCollapsed = true;
			}
    },
    onCloseApp() {
      if (this.isReportModifiedReportViewer) {
        return 'You have changes to the report without saving. Do you want to leave without saving?';
      }
    },
		toggleSidebar() {
			this.isNavbarCollapsed = !this.isNavbarCollapsed;
    },
		updateWindowSize() {
      this.isSmallScreen = window.innerWidth < 1160;
			if(this.isSmallScreen){
				this.isNavbarCollapsed = true;
			}
    },
  },
};
</script>

<style scoped>
.opaque-main-div {
  width: 100vw;
  height: 100vh;
  background-color: #eee;
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}
.opaque-main-loading {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.top-nav-bar-lg {
  height: 8vh;
  border: #ddd 2px solid;
  font-size: 1rem;
  z-index: 100;
  background: white;
  width: 94vw;
	margin-top:1px;
	padding-bottom: 1px;
}

li {
  display: inherit;
}

::v-deep #learning-sidebar {
  top: 8vh;
  height: 92vh !important;
}

.hold-sign {
  width: 10%;
  font-size: 0.5rem;
  font-weight: bolder;
  background-color: white;
  color: white;
  border-radius: 5px;
  text-align: center;
  margin-left: auto;
  cursor: pointer;
}

.hold-sign-show {
  background-color: cornflowerblue;
  cursor: pointer;
}

::v-deep #learning-sidebar .b-sidebar-header {
  background-color: #ccc;
}

.cookies-div {
  width: 80%;
  font-size: 0.8rem;
}
.title-cookies {
  font-weight: bold;
}
.icon-help {
  color: #4dbf45;
}
.route-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.route-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.route-enter-active {
  transition: all 0.3s ease-out;
}

.route-leave-active {
  transition: all 0.3s ease-in;
}

.route-enter-to,
.route-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.main_content_wrapper {
  margin-left: 6vw;
}

.main_content {
  margin-top: 8vh;
  overflow-y: auto;
  height: 92vh;
  overflow-x: hidden;
}
.main_content_no_auth{
  margin-top: 5.5rem;
  overflow-y: auto;
  overflow-x: hidden;
}
.selected {
  background-color: #4dbf45; /* Set the background color to your desired highlight color */
  border-radius: 10px;
  color: #fff; /* Set the text color for better visibility */
}
/* Media query for screen sizes less than px */
@media (max-width: 1160px) {
  #nav-bar-top.collapsed {
    display:none; /* Collapsed height */
    transition: height 0.3s ease; /* Smooth transition animation */
  }
	#nav-bar-top.expanded  {
    height: 40vh; /* expanded height */
		width: 85vw;
		margin-left:5vw;
		padding-right:2vw;
  }
}
.navbar-collapse-button{
	right: 0rem;
	position: absolute;
	z-index:101;
	background-color: #4DBF45;
	width: 8vw;
}
.navbar-wrap .b-navbar-nav{
  flex-wrap: wrap;
}
.scrollable-container {
  overflow-y: auto;
}
</style>